export default "__VITE_ASSET__IiCeLxD2__"